import { Observable } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace DialogActions {
  export class Confirm {
    static readonly type = '[DIALOG] Confirm';
    constructor(
      public title: string,
      public body: string,
      public onConfirm: () => Observable<void>,
      public allowCancel = true,
      public confirmText?: string,
      public critical = false
    ) {}
  }
}
